<ng-container *ngIf="!!hasHotelPolicies">
  <div class="policiesDetail__cont">
    <div class="policiesDetail__header">
      <app-ds-typography
        [tag]="'h2'"
        [size]="isUserHistory ? fontSize.RG : fontSize.XS"
        [color]="fontColor.Primary"
        [fontFamily]="fontFamily.SemiBold"
        [text]="'BOOKING_MODULE.IMPORTANT_INFORMATION' | transloco">
      </app-ds-typography>
      <div class="policiesDetail__header-description" [class.is-user-history]="isUserHistory">
        <app-ds-typography
          [tag]="'h3'"
          [size]="fontSize.XXS"
          [color]="fontColor.Secondary"
          [fontFamily]="fontFamily.Regular"
          [text]="'BOOKING_MODULE.IMPORTANT_INFORMATION_DESCRIPTION' | transloco">
        </app-ds-typography>
      </div>
    </div>
    <div class="policiesDetail__policies">
      <div class="policiesDetail__policies-accordion">
        <app-ds-accordion
          [type]="accordionType"
          [size]="accordionSize"
          [initState]="!isUserHistory"
          [text]="'BOOKING_MODULE.IMPORTANT_INFORMATION_HEADER' | transloco">
          <div class="policiesDetail__policies-card">
            <app-ds-typography
              [size]="fontSize.XXXS"
              [color]="fontColor.Primary"
              [text]="hotelValidation.CommentContract">
            </app-ds-typography>
          </div>
        </app-ds-accordion>
      </div>
    </div>
  </div>
</ng-container>